// extracted by mini-css-extract-plugin
module.exports = {"container":"CSKHDangKyHistory_container__3h8ZA","item":"CSKHDangKyHistory_item__184RS"};